const iban = require('./iban')
const validator = {

    validate(value) {
        if (iban.isValid(value) == true) return true
        return false

    }
};
module.exports = validator;